export const isHtmlElement = (element: Element | null): element is HTMLElement => {
    return element instanceof HTMLElement;
};
